module.exports = __webpack_public_path__ + "media/images/guide-thumb-5t-82b58ef0d0cf612f0ee7cfc04417df09.png";